import { TranslationKeys } from "../types";
import { SITE_CONFIG } from "../../app/config";

export const fr: TranslationKeys = {
  hero: {
    title1: "POSSÈDE TON",
    title2: "SON",
    streamingRenting: "STREAMING",
    vinylCdForever: "VINYLE & CD",
    description: `Colle ta playlist Spotify. Reçois ta liste Vinyles & CDs. À toi pour de vrai. Lance ta collection physique.`,
    ctaName: SITE_CONFIG.name,
  },
  
  perks: {
    ownIt: {
      title: "À Toi Pour De Vrai",
      desc: "Pas d'abonnement. Pas de retrait. Paye une fois, garde pour toujours. La vraie propriété.",
    },
    quality: {
      title: "Le Physique, C'est Autre Chose",
      desc: "Chaleur analogique ou perfection numérique. Le streaming ne peut pas lutter.",
    },
    collection: {
      title: "Flex Ta Collection",
      desc: "L'étagère parfaite. De l'art au mur. Une vraie collection que tu peux toucher, pas juste un fichier.",
    },
  },
  
  form: {
    placeholder: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    go: "GO",
    tryExample: "Pas de playlist ? Essaie un exemple",
    errors: {
      emptyPlaylist: "Colle une URL ou ID de playlist Spotify pour continuer.",
      cloudflareCheck: "Vérification Cloudflare requise.",
      cloudflareValidation: "Échec de validation Cloudflare. Réessaie.",
    },
  },
  
  results: {
    scanning: "SCAN DE LA PLAYLIST",
    yourHaul: "TON BUTIN VINYLE & CD",
    playlist: "Playlist",
    tracksToAlbums: "titres → albums à posséder",
    track: "titre",
    tracks: "titres",
    oops: "OUPS !",
    unableToProcess: "Impossible de traiter la playlist.",
    noAlbumsFound: "AUCUN ALBUM TROUVÉ",
    noAlbumsDesc: "Rien trouvé pour cette playlist !",
    tryDifferent: "Tente une autre playlist avec plus de son.",
    albumsToOwn: "ALBUMS À POSSÉDER",
    comingSoon: "Bientôt dispo",
    ownIt: "POSSÉDER →",
  },
  
  share: {
    shareHaul: "🔥 PARTAGE TON BUTIN",
    linkCopied: "🔗 LIEN COPIÉ !",
    shared: "🚀 PARTAGÉ !",
    shareText: `🔥 Je lance ma collection vinyle & CD ! Check ma liste pour "{playlistName}" 💿🎵 #collectionvinyle #collectioncd #possedetamusique`,
  },
  
  affiliate: {
    disclosure: "Transparence :",
    disclosureText: `${SITE_CONFIG.name} participe au programme partenaire ${SITE_CONFIG.affiliatePartner}. On touche une commission sur les achats via nos liens, sans frais pour toi. Ça aide ${SITE_CONFIG.name} à rester gratuit !`,
    notice: `Info : Les liens ci-dessous sont affiliés. On peut gagner une commission, sans surcoût pour toi. Merci de soutenir ${SITE_CONFIG.name} !`,
  },
  
  faq: {
    title: "Questions Fréquentes",
    subtitle: "TOUT SAVOIR SUR LA POSSESSION DE TA MUSIQUE.",
    sponsored: "Sponsorisé",
    adTitle: "Plus de Matos Musique",
    adDesc: "Platines premium, rangements CD & plus",
    items: [
      {
        question: `Comment marche ${SITE_CONFIG.name} ?`,
        answer: "Colle une URL de playlist Spotify publique dans GoOffline. On scanne chaque titre, on trouve les versions physiques — vinyles, CDs et cassettes — et on te montre où les acheter avec les vrais prix Discogs. Du streaming à la possession en un clic.",
      },
      {
        question: `Est-ce que ${SITE_CONFIG.name} est gratuit ?`,
        answer: "Oui, GoOffline est entièrement gratuit. Pas d'inscription, pas d'abonnement, pas de frais cachés. On touche une petite commission quand tu achètes via nos liens affiliés, ce qui ne te coûte rien de plus et fait tourner l'outil.",
      },
      {
        question: "Ai-je besoin d'un compte Spotify ou d'une connexion ?",
        answer: "Aucun compte ni connexion nécessaire. Colle simplement un lien de playlist Spotify publique ou une URL de partage. On n'accède jamais à ton compte Spotify — on lit uniquement les titres de la playlist que tu partages.",
      },
      {
        question: "Quels formats de musique puis-je trouver — vinyle, CD ou cassette ?",
        answer: "GoOffline recherche des vinyles, CDs et cassettes. Chaque fiche album montre les formats disponibles avec les prix du marché actuels. Le vinyle et le CD sont les plus courants, tandis que la disponibilité des cassettes varie selon le titre.",
      },
      {
        question: "Ça marche avec les playlists Spotify privées ?",
        answer: "Actuellement, seules les playlists publiques sont prises en charge. Astuce rapide : mets ta playlist en public, scanne-la sur GoOffline, puis remets-la en privé. Ça prend environ 10 secondes.",
      },
      {
        question: "D'où viennent les prix ?",
        answer: "Tous les prix viennent de Discogs, la plus grande marketplace mondiale de vinyles et CDs avec plus de 80 millions d'annonces. On affiche des prix estimés basés sur de vraies données de marché pour te donner une estimation fiable avant l'achat.",
      },
      {
        question: "Les prix des vinyles et CDs sont-ils fiables ?",
        answer: "Les prix sont estimés à partir des données récentes du marché Discogs et reflètent les conditions réelles du marché. Le prix final peut varier selon le pressage, l'état et le vendeur. Considère ça comme un point de départ fiable pour budgétiser ta collection.",
      },
      {
        question: "Puis-je partager ma liste de vinyles et CDs ?",
        answer: "Oui ! Clique sur le bouton partager pour envoyer ton butin à tes amis ou le poster sur les réseaux sociaux. Chaque résultat a un lien partageable unique. Partager nous aide à rester gratuits et aide tes amis à découvrir la musique physique.",
      },
      {
        question: "Et si un album n'est pas trouvé ?",
        answer: "GoOffline marche le mieux avec les sorties connues — rock classique, jazz, hip-hop, tubes pop et catalogues légendaires ont les meilleurs taux de correspondance. Les nouvelles sorties indie ou 100% numériques n'ont peut-être pas encore de pressage physique. Plus l'album est iconique, meilleurs sont les résultats.",
      },
      {
        question: "Pourquoi acheter des vinyles ou CDs en 2026 ?",
        answer: "Les ventes de vinyles ont augmenté pendant 18 années consécutives et atteignent des sommets historiques. Les CDs font aussi leur retour, offrant une qualité audio sans perte à prix cassé. La musique physique, c'est la vraie possession — pas d'abonnement, pas de catalogues qui disparaissent, et une vraie présence sur l'étagère.",
      },
      {
        question: "Vinyle vs CD — quel format choisir ?",
        answer: "Le vinyle offre un son analogique chaud, une valeur de collection, de grandes pochettes 30 cm et fait un superbe objet de décoration. Les CDs sont plus abordables, portables, offrent un son numérique parfait et sont plus faciles à trouver. Les deux sont mieux que payer tous les mois pour de la musique qui peut disparaître des plateformes de streaming.",
      },
      {
        question: `${SITE_CONFIG.name} est-il affilié à Spotify ?`,
        answer: "Non. GoOffline est un outil indépendant créé pour les fans de musique qui veulent posséder leur collection. On utilise l'API publique de Spotify pour lire les données des playlists, mais on n'est ni soutenu ni affilié à Spotify de quelque manière que ce soit.",
      },
      {
        question: `Mes données sont-elles privées et sécurisées sur ${SITE_CONFIG.name} ?`,
        answer: "Absolument. On ne demande aucune connexion ni information personnelle. On lit uniquement les données des titres de l'URL de playlist publique que tu fournis. Pas de cookies de suivi, pas de vente de données. Ta vie privée est pleinement respectée.",
      },
      {
        question: "Pourquoi posséder sa musique plutôt que le streaming ?",
        answer: "Les services de streaming peuvent retirer des albums sans préavis quand les licences expirent. La musique physique est à toi pour toujours — pas d'algorithmes qui décident ce que tu écoutes, pas de fatigue des abonnements, pas de décisions d'entreprise sur ta bibliothèque. Et rien ne vaut le rituel de poser la platine sur un vinyle ou de tenir une pochette dans ses mains.",
      },
    ],
  },
  
  footer: {
    affiliateDisclosure: "Transparence :",
    copyright: `© ${new Date().getFullYear()} ${SITE_CONFIG.name} — Convertisseur Spotify vers Vinyle & CD`,
    converter: "Convertisseur Spotify vers Vinyle & CD",
    terms: "Conditions",
    privacy: "Confidentialité",
    affiliateLink: "Affiliation",
    notAffiliated: "Non affilié à Spotify",
  },
  
  ad: {
    label: "PUB",
    title: "Ta Pub Ici",
    desc: "Pub display responsive · 728×90 ou similaire",
  },
  
  language: {
    label: "Langue",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    pl: "Polski",
  },
};
